import axios from "axios";
import { FiltersRequiredError, NotImplementedError, parseNewNewYorkApiResponse } from "../../../..";
import { ObservableHandler } from "../../../../handlers";
import { Observable } from "rxjs";
import { toQueryParams } from "./filters/params";
import { parseIdFilter } from "../../../../handlers/filter";
import { isServicePage } from "../../../../handlers/page";
/**
 * Converts service response to client format following FE patterns
 */
export function servicePublisherTemplateBundleToPublisherTemplateBundle(serviceBundle) {
    return {
        bundleId: serviceBundle.id,
        publisherId: serviceBundle.pub_id,
        excluded: serviceBundle.excluded,
        publisherName: "" // Will be populated by frontend publisher lookup
    };
}
/**
 * Handles publisher template bundle operations.
 * Bundles are version histories of a template, and are thus just an array of Bundles.
 */
class PublisherTemplateBundles extends ObservableHandler {
    constructor(sdk) {
        super(sdk, "publishers.optimizationTemplates.bundles");
    }
    /**
     * Find a bundle based on a template ID.
     *
     * @param filters: filter template bundles by a given template ID (e.g., {where: [field: "id", type: FilterTypes.EQ, value: "1"]}).
     *          Supports (and requires):
     *              {FilterTypes.EQ, "id"}
     */
    findItems(filters) {
        const idFilter = parseIdFilter(filters);
        if (!idFilter) {
            throw new FiltersRequiredError("id");
        }
        return new Observable((subscriber) => {
            this.getTemplateBundles(filters)
                .then((bundles) => {
                subscriber.next(bundles);
                subscriber.complete();
            })
                .catch((error) => {
                subscriber.error(error);
            });
        });
    }
    async getTemplateBundles(filters = {}) {
        const templateId = filters.where?.find((filter) => filter.field === "id")
            ?.value;
        if (!templateId) {
            throw new FiltersRequiredError("templateId");
        }
        const params = toQueryParams(filters);
        const pageSize = filters?.paging?.size || 10;
        const url = `${this.sdk.urls.baseAPIUrl}/publisher-template-bundle-rules/${templateId}${params}`;
        return this.cache.promise(`${url}`, () => axios
            .get(`${url}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
            const rawBundleData = parseNewNewYorkApiResponse(res);
            // Convert service response to client format
            const convertedData = rawBundleData.data.map(servicePublisherTemplateBundleToPublisherTemplateBundle);
            let results = convertedData;
            if (isServicePage(rawBundleData)) {
                results = {
                    page: {
                        count: rawBundleData.paging_info.count,
                        token: rawBundleData.paging_info.token,
                        size: pageSize
                    },
                    data: convertedData
                };
            }
            return results;
        })
            .catch((error) => {
            throw error;
        }));
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    make(bundle) {
        throw new NotImplementedError("make");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    saveItem(bundle) {
        throw new NotImplementedError("save");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    async deleteItem(id) {
        throw new NotImplementedError("delete");
    }
}
export default PublisherTemplateBundles;
//# sourceMappingURL=index.js.map